import domready from 'domready'
import { nodelistToArray } from '../lib/nodelistToArray'
import { uuid } from '../lib/uuid'
import levendeStillbilde from '@nrk/dh-basis-levende-stillbilde'
import { ElementIntersectionObserver } from '@nrk/dh-basis-common'
import styles from './components/VideoLoop.css'
import * as Sentry from '@sentry/browser'

const rootElementClassName = 'article-levende-stillbilde-root'

window[rootElementClassName] = window[rootElementClassName] || {}
window.isDhSentryInitiated = false

const VIEWPORT_POSITION_ATTR = 'data-viewport-position'

function init () {
  if (!window.isDhSentryInitiated) {
    initSentry()
  }
  initCustomElements()

  const elementsArray = nodelistToArray(document.getElementsByClassName(rootElementClassName))
  elementsArray
    .filter(el => !isInitialized(el))
    .forEach(el => {
      el.id = uuid()
      window[rootElementClassName][el.id] = true

      // Extract preloaded state sent from server
      const preloadedState = JSON.parse(el.getAttribute('data-preloaded-state'))
      mount(el, preloadedState)
    })
}

function mount (el, preloadedState) {
  try {
    // Checks to see whether or not the video element is inside the a feature article cover
    const insideCover = Boolean(document.querySelector(`.article-feature__cover #${el.id}`))
    const captionEl = document.querySelector(`#${el.id} [data-caption]`)
    if (insideCover && captionEl) {
      captionEl.parentNode.replaceChild(
        headingCaption(preloadedState.altText, preloadedState.byline),
        captionEl
      )
    }

    const videoWrapperElement = el.querySelector('.dh-video-wrapper')

    // eslint-disable-next-line no-unused-vars
    const elementObserver = new ElementIntersectionObserver([videoWrapperElement], (intersections) => {
      const element = intersections[0]
      const elementViewportPosition = videoWrapperElement.getAttribute(VIEWPORT_POSITION_ATTR)
      if (element.isIntersecting && elementViewportPosition === 'OUT-OF-VIEWPORT') {
        videoWrapperElement.setAttribute(VIEWPORT_POSITION_ATTR, 'IN-VIEWPORT')
      }
      if (!element.isIntersecting && elementViewportPosition === 'IN-VIEWPORT') {
        videoWrapperElement.setAttribute(VIEWPORT_POSITION_ATTR, 'OUT-OF-VIEWPORT')
      }
    })
  } catch (err) {
    // fail silently
  }
}

function headingCaption (altText, byline) {
  const captionContainer = document.createElement('div')
  captionContainer.innerHTML = `<span class='nrk-sr'>${altText}</span><span>${byline}</span>`
  captionContainer.setAttribute('class', styles['byline'])
  captionContainer.setAttribute('data-caption', true)
  return captionContainer
}

function initSentry () {
  Sentry.init({
    dsn: 'https://61a06075b4944857a732bd9ae155c639@sentry.io/2432586',
    sampleRate: 0.3
  })
  window.isDhSentryInitiated = true
}

function initCustomElements () {
  if (typeof customElements.get('dh-lvs-basis-levende-stillbilde') === 'undefined') {
    customElements.define('dh-lvs-basis-levende-stillbilde', levendeStillbilde)
  }
}

function isInitialized (el) {
  return el.id && window[rootElementClassName][el.id]
}

domready(() => {
  if (!('customElements' in window)) {
    require('@webcomponents/custom-elements')
  }
  if (!('IntersectionObserver' in window)) {
    require('intersection-observer')
  }
  init()
})



// WEBPACK FOOTER //
// ./src/article/client.videoLoop.js